import i18n from "../i18n";

const changeLanguage = (lng: string) => {
  i18n.changeLanguage(lng);
};

export default changeLanguage;
